unit UMainConfig;

interface

uses
  UUserModel, UMenuConfig, UEssentialHelper, UColorConfig, UOverviewConfig,
  UCommonConfig, UClockInConfig, UTimeDataConfig, Js, UAppForLeaveConfig,
  WebLib.Controls, UTransferList, UBarcodeScannerConfig, UWebSpeechRec;

const
  VERSION = '20260720.1411';

type
  TMainConfig = class
  private
    FUser: TUserModel;
    FUri: string;
    FCopyright: string;
    FMenuConfig: TMenuConfig;
    FOnPorpertyChanged: TCallback;
    FColorConfig: TColorConfig;
    FOverviewConfig: TOverviewConfig;
    FCommonConfig: TCommonConfig;
    FClockInConfig: TClockInConfig;
    FTimeDataConfig: TTimeDataConfig;
    FAppForLeaveConfig: TAppForLeaveConfig;
    FOnTimerReset: TCallback;
    FCurrentForm: string;
    FOnError: TErrorEvent;
    FTransferList: TTransferList;
    FBarcodeScannerConfig: TBarcodeScannerConfig;
    FSpeechRec: TSpeechRec;
    procedure ClearValues;
    procedure DoError(AMsg: string);
    procedure PropertyChanged;
    procedure SetValues(json: string); overload;
    procedure SetValues(obj: TJsObject); overload;
    procedure SetUser(const Value: TUserModel);
    procedure SetUri(const Value: string);
    procedure SetCopyright(const Value: string);
    procedure SetMenuConfig(const Value: TMenuConfig);
    procedure SetOnPorpertyChanged(const Value: TCallback);
    procedure SetColorConfig(const Value: TColorConfig);
    procedure SetOverviewConfig(const Value: TOverviewConfig);
    procedure SetCommonConfig(const Value: TCommonConfig);
    procedure SetClockInConfig(const Value: TClockInConfig);
    procedure SetTimeDataConfig(const Value: TTimeDataConfig);
    procedure SetAppForLeaveConfig(const Value: TAppForLeaveConfig);
    procedure SetOnTimerReset(const Value: TCallback);
    procedure SetCurrentForm(const Value: string);
    procedure SetOnError(const Value: TErrorEvent);
    procedure SetTransferList(const Value: TTransferList);
    procedure SetBarcodeScannerConfig(const Value: TBarcodeScannerConfig);
    procedure SetSpeechRec(const Value: TSpeechRec);
  public
    constructor Create;
    procedure GetConfig;
    procedure TimerReset;
    property User: TUserModel read FUser write SetUser;
    property Uri: string read FUri write SetUri;
    property Copyright: string read FCopyright write SetCopyright;
    property MenuConfig: TMenuConfig read FMenuConfig write SetMenuConfig;
    property ColorConfig: TColorConfig read FColorConfig write SetColorConfig;
    property OverviewConfig: TOverviewConfig read FOverviewConfig
      write SetOverviewConfig;
    property CommonConfig: TCommonConfig read FCommonConfig
      write SetCommonConfig;
    property ClockInConfig: TClockInConfig read FClockInConfig
      write SetClockInConfig;
    property TimeDataConfig: TTimeDataConfig read FTimeDataConfig
      write SetTimeDataConfig;
    property AppForLeaveConfig: TAppForLeaveConfig read FAppForLeaveConfig
      write SetAppForLeaveConfig;
    property OnPorpertyChanged: TCallback read FOnPorpertyChanged
      write SetOnPorpertyChanged;
    property OnTimerReset: TCallback read FOnTimerReset write SetOnTimerReset;
    property CurrentForm: string read FCurrentForm write SetCurrentForm;
    property OnError: TErrorEvent read FOnError write SetOnError;
    property TransferList: TTransferList read FTransferList
      write SetTransferList;
    property BarcodeScannerConfig: TBarcodeScannerConfig
      read FBarcodeScannerConfig write SetBarcodeScannerConfig;
    property SpeechRec: TSpeechRec read FSpeechRec write SetSpeechRec;
  end;

implementation

uses
  System.SysUtils, WebLib.REST, WebLib.json, WebLib.Storage;

{ TMainConfig }

procedure TMainConfig.ClearValues;
begin
  Self.MenuConfig := TMenuConfig.Create;
  Self.ColorConfig := TColorConfig.Create;
  Self.OverviewConfig := TOverviewConfig.Create;
  Self.CommonConfig := TCommonConfig.Create;
  Self.ClockInConfig := TClockInConfig.Create;
  Self.TimeDataConfig := TTimeDataConfig.Create;
  Self.AppForLeaveConfig := TAppForLeaveConfig.Create;
  Self.CurrentForm := '';
  Self.BarcodeScannerConfig := TBarcodeScannerConfig.Create;
end;

constructor TMainConfig.Create;
begin
  Self.User := TUserModel.Create;
  Self.Uri := 'http://192.168.178.77:8077/delco';
  Self.Copyright := 'Version: ' + VERSION + ' © ' + FormatDateTime('yyyy', date)
    + ' DELCO Datentechnik GmbH';
  Self.OnPorpertyChanged := nil;
  Self.OnTimerReset := nil;
  Self.OnError := nil;
  Self.SpeechRec:=TSpeechRec.Create;
end;

procedure TMainConfig.DoError(AMsg: string);
begin
  if Assigned(Self.OnError) then
    Self.OnError(Self, AMsg);
end;

procedure TMainConfig.GetConfig;
var
  client: TRestClient;
  cmd: string;
  procedure ConfigResponse(Sender: TObject; AResponse: string);
  var
    obj: TJsObject;
  begin
    Self.ClearValues;
    if AResponse <> '' then
      TLocalStorage.SetValue(cmd, AResponse)
    else
      AResponse := TLocalStorage.GetValue(cmd);
    if AResponse <> '' then
    begin
      obj := TJsJson.parseObject(AResponse);
      if obj['value'] <> nil then
        Self.SetValues(string(obj['value']));
      Self.PropertyChanged;
    end
    else
      Self.DoError('Verbindungsfehler: TMainConfig.GetConfig');
  end;

  procedure ErrorHandler(Sender: TObject; ARequest: TJSXMLHttpRequestRecord;
    Event: TJSEventRecord; var Handled: Boolean);
  begin
    Handled := true;
    ConfigResponse(Self, '');
  end;

begin
  client := TRestClient.Create(nil);
  client.OnResponse := ConfigResponse;
  client.OnError := ErrorHandler;
  cmd := Self.Uri + '/ConfigService/GetConfig';
  client.HttpsGet(cmd);
end;

procedure TMainConfig.PropertyChanged;
begin
  if Assigned(Self.OnPorpertyChanged) then
    Self.OnPorpertyChanged(Self);
end;

procedure TMainConfig.SetAppForLeaveConfig(const Value: TAppForLeaveConfig);
begin
  FAppForLeaveConfig := Value;
end;

procedure TMainConfig.SetBarcodeScannerConfig(const Value
  : TBarcodeScannerConfig);
begin
  FBarcodeScannerConfig := Value;
end;

procedure TMainConfig.SetClockInConfig(const Value: TClockInConfig);
begin
  FClockInConfig := Value;
end;

procedure TMainConfig.SetColorConfig(const Value: TColorConfig);
begin
  FColorConfig := Value;
end;

procedure TMainConfig.SetCommonConfig(const Value: TCommonConfig);
begin
  FCommonConfig := Value;
end;

procedure TMainConfig.SetCopyright(const Value: string);
begin
  FCopyright := Value;
end;

procedure TMainConfig.SetCurrentForm(const Value: string);
begin
  FCurrentForm := Value;
end;

procedure TMainConfig.SetMenuConfig(const Value: TMenuConfig);
begin
  FMenuConfig := Value;
end;

procedure TMainConfig.SetOnError(const Value: TErrorEvent);
begin
  FOnError := Value;
end;

procedure TMainConfig.SetOnPorpertyChanged(const Value: TCallback);
begin
  FOnPorpertyChanged := Value;
end;

procedure TMainConfig.SetOnTimerReset(const Value: TCallback);
begin
  FOnTimerReset := Value;
end;

procedure TMainConfig.SetOverviewConfig(const Value: TOverviewConfig);
begin
  FOverviewConfig := Value;
end;

procedure TMainConfig.SetSpeechRec(const Value: TSpeechRec);
begin
  FSpeechRec := Value;
end;

procedure TMainConfig.SetTimeDataConfig(const Value: TTimeDataConfig);
begin
  FTimeDataConfig := Value;
end;

procedure TMainConfig.SetTransferList(const Value: TTransferList);
begin
  FTransferList := Value;
end;

procedure TMainConfig.SetUser(const Value: TUserModel);
begin
  FUser := Value;
end;

procedure TMainConfig.SetValues(obj: TJsObject);
begin
  Self.ClearValues;
  if obj['MenuConfig'] <> nil then
    Self.MenuConfig := TMenuConfig.Create(string(obj['MenuConfig']));
  if obj['ColorConfig'] <> nil then
    Self.ColorConfig := TColorConfig.Create(string(obj['ColorConfig']));
  if obj['OverviewConfig'] <> nil then
    Self.OverviewConfig := TOverviewConfig.Create
      (string(obj['OverviewConfig']));
  if obj['CommonConfig'] <> nil then
    Self.CommonConfig := TCommonConfig.Create(string(obj['CommonConfig']));
  if obj['ClockInConfig'] <> nil then
    Self.ClockInConfig := TClockInConfig.Create(string(obj['ClockInConfig']));
  if obj['TimeDataConfig'] <> nil then
    Self.TimeDataConfig := TTimeDataConfig.Create
      (string(obj['TimeDataConfig']));
  if obj['AppForLeaveConfig'] <> nil then
    Self.AppForLeaveConfig := TAppForLeaveConfig.Create
      (string(obj['AppForLeaveConfig']));
  if obj['BarcodeScannerConfig'] <> nil then
    Self.BarcodeScannerConfig := TBarcodeScannerConfig.Create
      (string(obj['BarcodeScannerConfig']));
end;

procedure TMainConfig.TimerReset;
begin
  if Assigned(Self.OnTimerReset) then
    Self.OnTimerReset(Self.CommonConfig);
end;

procedure TMainConfig.SetValues(json: string);
var
  obj: TJsObject;
begin
  if json <> '' then
  begin
    obj := TJsJson.parseObject(json);
    Self.SetValues(obj);
  end;
end;

procedure TMainConfig.SetUri(const Value: string);
begin
  if FUri <> Value then
  begin
    FUri := Value;
    Self.TransferList := TTransferList.Create(Self.Uri);
  end;
end;

end.
